import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const ServicesContainer = styled.div`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
`;

export const ServicesHero = styled.div`
  position: relative;
  padding: 6rem 1rem 4rem;
  background: #FFFFFF;
  text-align: center;
  
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 0V100M21 0V100M41 0V100M61 0V100M81 0V100M0 1H100M0 21H100M0 41H100M0 61H100M0 81H100' stroke='%232C3E50' stroke-opacity='0.1'/%3E%3C/svg%3E"),
      url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 0V100M21 0V100M41 0V100M61 0V100M81 0V100M0 1H100M0 21H100M0 41H100M0 61H100M0 81H100' stroke='%234CAF50' stroke-opacity='0.15'/%3E%3C/svg%3E");
    background-size: 100px 100px;
    background-position: 0 0;
    mask-image: linear-gradient(180deg, white 0%, white 80%, rgba(255,255,255,0) 100%);
    z-index: 0;
  }
`;

export const ServicesContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: ${({ theme }) => theme.sizes.maxWidth};
  margin: 0 auto;
`;

export const ServicesTitle = styled.h1`
  position: relative;
  z-index: 1;
  font-size: 2.5rem;
  font-family: ${({ theme }) => theme.fonts.serif};
  font-weight: 700;
  color: #111827;
  margin-bottom: 1rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  letter-spacing: -0.025em;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 3rem;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: 3.5rem;
  }
`;

export const ServicesSubtitle = styled.p`
  position: relative;
  z-index: 1;
  font-size: 1.25rem;
  color: #374151;
  max-width: 48rem;
  margin: 0 auto 2rem;
  font-weight: 400;
  line-height: 1.6;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 1.5rem;
  }
`;

export const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  max-width: ${({ theme }) => theme.sizes.maxWidth};
  margin: 0 auto;
  padding: 2rem 1rem;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(2, 1fr);
    padding: 3rem 1.5rem;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 4rem 2rem;
  }
`;

export const ServiceCard = styled.div`
  background-color: #FFFFFF;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding: 2rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
`;

export const ServiceIcon = styled.div`
  color: #4CAF50;
  margin-bottom: 1.5rem;
`;

export const ServiceTitle = styled.h2`
  font-size: 1.75rem;
  font-family: ${({ theme }) => theme.fonts.serif};
  font-weight: 700;
  color: #111827;
  margin-bottom: 1rem;
  letter-spacing: -0.025em;
  line-height: 1.2;
  position: relative;
  padding-bottom: 0.75rem;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 3rem;
    height: 3px;
    background-color: #4CAF50;
    border-radius: 2px;
  }
`;

export const ServiceDescription = styled.p`
  font-size: 1.25rem;
  color: #4B5563;
  margin-bottom: 2rem;
  font-weight: 400;
  line-height: 1.5;
  padding-left: 0.5rem;
  border-left: 3px solid rgba(76, 175, 80, 0.2);
`;

export const ServiceDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const ServiceDetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ServiceDetailTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
`;

export const ServiceDetailText = styled.p`
  font-size: 1rem;
  color: #4B5563;
  font-weight: 300;
  line-height: 1.5;
`;

export const ContactSection = styled.section`
  background-color: #F9FAFB;
  padding: 4rem 1rem;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 5rem 1.5rem;
  }
  
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 6rem 2rem;
  }
`;

export const ContactContent = styled.div`
  max-width: ${({ theme }) => theme.sizes.maxWidth};
  margin: 0 auto;
  text-align: center;
`;

export const ContactTitle = styled.h2`
  font-size: 2rem;
  font-family: ${({ theme }) => theme.fonts.serif};
  font-weight: 700;
  color: #111827;
  margin-bottom: 1rem;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 2.5rem;
  }
`;

export const ContactText = styled.p`
  font-size: 1.125rem;
  color: #4B5563;
  max-width: 36rem;
  margin: 0 auto 2rem;
  font-weight: 300;
`;

export const ContactButton = styled(Link)`
  display: inline-block;
  background-color: #111827;
  color: white;
  font-weight: 600;
  padding: 0.75rem 2rem;
  border-radius: 0.375rem;
  text-decoration: none;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #1F2937;
  }
`; 